import { Vue, Prop, Watch, Component } from 'vue-property-decorator';
import moment from 'moment';
import type { ElForm } from 'element-ui/types/form';
import ExportFile from '../exportFile';
import batchAdd from './batchAdd';
import operateHistory from './operateHistory';
import style from './style.vue';
import { noop } from '@/util';
import { IPSService } from '@/services/ipsServices';
import selectGoods from '@/views/components/selectGoods';

enum SORT_TYPE {
  UDATE_TIME, // 更新时间倒叙
  ORIGIN_PRICE_DESC, // 牌价倒叙
  ORIGIN_PRICE_ASC, // 牌价正序
  PRICE_DESC, // 现价倒叙3
  PRICE_ASC, // 现价正序4
  STOCK_DESC, // 库存倒叙5
  STOCK_ASC, // 库存正序6
  SALE_DESC, // 销量倒叙7
  SALE_ASC, // 销量正序8
  COUPON_DESC, // 优惠券倒序9
  COUPON_ASC, // 优惠券正序10
}

interface SiteProduct {
  productId?: number; // 商品自增Id
  productName?: string; // 商品名称
  productImage?: string; // 商品图片
  productCode?: string; // 货号
  originPrice?: number; // 原价
  price?: number; // 现价
  stock?: number; // 库存
  changeStatePerson: string; // 上下架操作者
  changeStateTime: number; // 上下架时间
  isLine: number; // 上下架状态
  empCode: string; // 更新人编号
  updatePerson: string; // 更新人名称
  saleNum?: number; // 销量
  productState?: 0 | 1 | 2; // 商品状态 0 已下架 1 销售中 2 已售罄
  updateTime?: number; // 更新时间
}

@Component({
  mixins: [style],
	components: {
		ExportFile,
	}
})
export default class ProductWhiteList extends Vue {
  // 商品状态 9 全部 1 销售中  2 已售罄 3 已下架
  @Prop({ default: 9 })
    pType: number;

  @Prop()
    propKeyword: string;

  @Prop()
    propPage: number;

  @Prop()
    propPageSize: number;

  @Prop()
    propSort: number;

  @Prop()
    siteId: number;

  // 索引
  $refs: {
    pTable: ElForm;
  };

  // 页码
  page = 1;

  //  每页显示数量
  pageSize = 10;

  //  总数
  totalCount = 0;

  //  搜索关键字
  keyword = '';

  // 加载状态
  loadingState = false;

  // 商品列表
  pData: SiteProduct[] = [];

  // 选中项
  tableSelected = [];

  // 升序 或 降序
  sortBy = 0;

  @Watch('pType', { immediate: true, deep: true })
  watchType(n, o) {
    if (o) {
      // @ts-expect-error
      this.$refs.pTable.clearSort();
    }
    this.sortBy = this.propSort;
    this.page = this.propPage;
    this.pageSize = this.propPageSize;
    this.keyword = this.propKeyword;
    this.getData();
  }

  @Watch('sortBy', { deep: true })
  sortWatch(n) {
    this.$emit('sortChange', n);
  }

  @Watch('page', { deep: true })
  pagetWatch(n) {
    this.$emit('pageChange', n);
  }

  @Watch('pageSize', { deep: true })
  pageSizeWatch(n) {
    this.$emit('pageSizeChange', n);
  }

  @Watch('keyword', { deep: true })
  keywordWatch(n) {
    this.$emit('keywordChange', n);
  }

  get exportParams() {
    const productIds = this.tableSelected.map(v => v.productId);
    const postParams = {
      exportType: 'productList',
      params: { siteId: this.siteId, keyword: this.keyword, productState: this.pType, sort: this.sortBy, productIds },
    };

    return postParams;
  }

  onPageChange(val) {
    this.page = val;
    this.getData();
  }

  onPageSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getData();
  }

  onSortChange(column) {
    switch (column.prop) {
      case 'originPrice':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.ORIGIN_PRICE_ASC : SORT_TYPE.ORIGIN_PRICE_DESC;
        break;
      case 'price':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.PRICE_ASC : SORT_TYPE.PRICE_DESC;
        break;
      case 'stock':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.STOCK_ASC : SORT_TYPE.STOCK_DESC;
        break;
      case 'saleNum':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.SALE_ASC : SORT_TYPE.SALE_DESC;
        break;
      case 'couponNum':
        this.sortBy = column.order === 'ascending' ? SORT_TYPE.COUPON_ASC : SORT_TYPE.COUPON_DESC;
        break;
      default:
        this.sortBy = SORT_TYPE.UDATE_TIME;
        break;
    }
    this.getData();
  }

  // 删除
  onDel(productId, openState = -1) {
    this.$confirm('确定将当前商品删除？', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.batchUpdateState(openState, [productId]);
      }
    }, noop);
  }

  // 选中
  onSelected(val) {
    this.tableSelected = val;
  }

  // 添加商品
  addProduct() {
    selectGoods.open({ multiple: false, showBD: false, siteId: this.siteId }).then();
  }

  // 批量添加
  batchAdd() {
    batchAdd
      .open({
        path: this.$route.path,
        urlPrams: this.$route.params,
        importUrl: '/admin/add/product/import',
        importParams: { siteId: this.siteId },
        title: '批量导入商品',
        siteId: this.siteId,
        notShelf: true,
      })
      .then((result) => {
        this.getData();
      }, noop);
  }

  // 批量删除
  batchDel() {
    if (!this.tableSelected || !this.tableSelected.length) {
      return;
    }
    this.$confirm(`确认将当前选中的${this.tableSelected.length}件商品删除？`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.batchUpdateState(-1);
      }
    });
  }

  /**
   * 批量修改状态
   * @param openState  0 下架 1 上架 - 1 删除
   * @param productIds
   * @returns null
   */
  batchUpdateState(openState, productIds = null): void {
    if (!productIds) {
      productIds = this.tableSelected.map(v => v.productId);
    }
    IPSService.siteProductState({
      postParams: {
        openState,
        productIds: productIds || this.tableSelected.map(v => v.productId),
        siteId: this.siteId,
      },
    }).then(() => {
      this.$message.success('操作成功');
      if (openState === -1) {
        this.page = 1;
      }
      this.getData();
    });
  }

  // 获取数据
  getData() {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
      target: '.categoryConfig',
    });
    const postParams = {
      siteId: this.siteId,
      keyword: this.keyword,
      productState: this.pType,
      page: this.page,
      pageSize: this.pageSize,
      sort: this.sortBy,
    };

    IPSService.siteProductList({
      postParams,
    }).then(
      (response) => {
        loading.close();
        this.totalCount = response.count || 0;
        this.pData = response.list.map((v) => {
          return Object.assign({}, v, {
            updateTimeStr: moment(v.updateTime * 1000).format('YYYY-MM-DD HH:mm'),
          });
        });
      },
      () => {
        loading.close();
      },
    );
  }

  openHistory() {
    operateHistory.open({}).then(() => {});
  }

  onSearch() {
    this.page = 1;
    this.getData();
  }

  renderTableBtn(h, val) {
    const { productId } = val;
    return (
      <div>
        <span class="scopeSpan r-pl-12" onClick={this.onDel.bind(this, productId, -1)}>
          删除
        </span>
      </div>
    );
  }

  render(h) {
    return (
      <div class="p-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword} placeholder="商品货号/商品名称" />
            <i class="iconfont iconsousuo" onClick={this.onSearch.bind(this)} />
          </div>
        </div>

        <div class="tableWrapper width-100">
          <el-table ref="pTable" data={this.pData} v-loading={this.loadingState} height={'calc(100% - 91px)'} on-sort-change={this.onSortChange.bind(this)} on-selection-change={this.onSelected} element-loading-text="加载中" tooltip-effect="light">
            <el-table-column type="selection" width="55px" align="center" fixed="left" />
            <el-table-column type="index" label="#" width="55" align="left" fixed="left" />
            <el-table-column
              prop=""
              label="商品"
              align="left"
              width="260"
              fixed="left"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <div class="p-info">
                        <img class="p-pic" src={scope.row.productImage} />
                        <div class="p-name">{scope.row.productName}</div>
                      </div>
                    );
                  },
                },
              }}
            />
            <el-table-column prop="productCode" label="货号" width="240" align="left" show-overflow-tooltip={true} />
            <el-table-column
              prop="originPrice"
              label="牌价(元)"
              align="right"
              header-align="right"
              width="200"
              sortable
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <span>￥{scope.row.originPrice != scope.row.maxOriginPrice ? `${Math.min(scope.row.maxOriginPrice, scope.row.originPrice)}~￥${Math.max(scope.row.maxOriginPrice, scope.row.originPrice)}` : scope.row.originPrice}</span>;
                  },
                },
              }}
            />
            <el-table-column
              prop="updatePerson"
              label="更新人"
              align="center"
              width="200"
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div class="rp-r-0">{scope.row.updatePerson}</div>;
                  },
                },
              }}
            />
            <el-table-column
              prop="updateTimeStr"
              label="更新时间"
              align="left"
              width="250"
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div class="rp-l-10 rp-r-0">{scope.row.updateTimeStr}</div>;
                  },
                },
              }}
            />
            <el-table-column
              prop=""
              label="操作"
              align="center"
              width="180"
              fixed="right"
              {...{
                scopedSlots: {
                  default: (scoped) => {
                    return this.renderTableBtn(h, scoped.row);
                  },
                },
              }}
            />
          </el-table>
          <div class="bottomWrapper">
            <el-button type="primary" onClick={this.addProduct.bind(this)}>
              添加商品
            </el-button>
            <span class="scopeSpan" onClick={this.batchAdd.bind(this)}>
              批量导入商品
            </span>
            <span class={[(!this.tableSelected || !this.tableSelected.length) && 'disabled', 'scopeSpan']} onClick={this.batchDel.bind(this)}>
              删除
            </span>
            <ExportFile export-text="下载为Excel" params={this.exportParams} http-type={'post'} is-button={false} service-url="adminExport"></ExportFile>
            <span class="scopeSpan" onClick={this.openHistory.bind(this)}>
              操作履历
            </span>
            <el-pagination
              on-size-change={this.onPageSizeChange}
              on-current-change={this.onPageChange}
              current-page={this.page}
              page-sizes={[10, 30, 60, 100]}
              pager-count={5}
              page-size={this.pageSize}
              layout="total, sizes, prev, pager, next, jumper"
              total={this.totalCount}
            />
          </div>
        </div>
      </div>
    );
  }
}
